module.exports = __webpack_public_path__ + "static/media/select.3c6dd860.wav";